<template>
    <p class="field-title">
        {{ label }}
        <TooltipComponent v-if="item.description" :description="item.description" />
    </p>

    <InputText :disabled="disableEdit" class="input-text" type="text" :value="modelValue" :placeholder="placeholder"
        @input="handleInput" />

    <FileUpload v-if="item.attachment_required" @saved="onSaved" :isImage="false" :isAttachment="true" :id="partnerId"
        :fieldId="item.id" :logoUrl="attachmentLink" :disabled="disableEdit" />

    <p v-if="v$.modelValue.$error" class="error-msg">
        {{ error_message }}
    </p>
</template>

<script>
import { computed, watch } from 'vue';
import InputText from 'primevue/inputtext';
import { useVuelidate } from '@vuelidate/core';
import { between, minLength, maxLength, integer } from '@vuelidate/validators';
import TooltipComponent from './TooltipComponent.vue';
import FileUpload from '../common/FileUpload';

export default {
    name: 'ShortTextInputComponent',
    components: {
        InputText,
        TooltipComponent,
        FileUpload,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        modelValue: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        error_message: {
            type: String,
        },
        validation_rules: {
            type: Object,
            default: () => ({}),
        },
        attachmentLink: {
            type: String,
        },
        disableEdit: {
            type: Boolean,
            required: true,
        },
    },
    setup(props, { emit }) {
        const decimal = (value) => {
            return /^-?\d*\.?\d*$/.test(value) || false;
        };
        const rules = computed(() => {
            const validationRules = {};
            if (props.validation_rules.betweenValue) {
                validationRules.between = between(
                    props.validation_rules.betweenValue.min,
                    props.validation_rules.betweenValue.max
                );
            } else if (props.validation_rules.dataType === 'Numeric') {
                validationRules.number = integer;
                validationRules.minLength = minLength(props.validation_rules.minLength);
                validationRules.maxLength = maxLength(props.validation_rules.maxLength);
            } else if (props.validation_rules.dataType === 'Decimal') {
                validationRules.number = decimal;
                validationRules.minLength = minLength(props.validation_rules.minLength);
                validationRules.maxLength = maxLength(props.validation_rules.maxLength);
            }
            return {
                modelValue: validationRules,
            };
        });

        const v$ = useVuelidate(rules, props);

        let partnerId = localStorage.getItem('accountId');

        watch(
            () => props.modelValue,

            () => {
                v$.value.$touch();
                if (!v$.value.$error) {
                    emit('isValid', true);
                } else {
                    emit('isValid', false);
                }
            }
        );

        const handleInput = (event) => {
            emit('update:modelValue', event.target.value);
            v$.value.$touch();
            if (!v$.value.$error) {
                emit('isValid', true);
            } else {
                emit('isValid', false);
            }
        };

        return { v$, handleInput, partnerId };
    },
};
</script>
